var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "navbar navbar-expand flex-column flex-md-row navbar-custom",
    },
    [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.config && _vm.userRole
            ? _c(
                "router-link",
                {
                  staticClass: "navbar-brand mr-0 mr-md-2 logo",
                  attrs: { to: "/" + _vm.userRole.toLocaleLowerCase() },
                },
                [
                  _c("span", { staticClass: "logo-lg" }, [
                    _c("img", {
                      attrs: {
                        src: require("@assets/images/logo.png"),
                        alt: "Copy Engine",
                        width: "200",
                      },
                    }),
                  ]),
                  _c("span", { staticClass: "logo-sm" }, [
                    _c("img", {
                      attrs: {
                        src: require("@assets/images/favicon.png"),
                        alt: "Copy Engine",
                        height: "40",
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "ul",
            {
              staticClass:
                "navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0 mr-auto",
            },
            [
              _c("li", [
                _c(
                  "button",
                  {
                    staticClass: "button-menu-mobile open-left",
                    class: { open: _vm.isMenuOpened },
                    on: { click: _vm.toggleMenu },
                  },
                  [
                    _c("feather", {
                      staticClass: "menu-icon align-middle",
                      attrs: { type: "menu" },
                    }),
                    _c("feather", {
                      staticClass: "close-icon",
                      attrs: { type: "x" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm.user && _vm.user.total_credits > 0
                ? _c("li", { staticClass: "d-none d-sm-block" }, [
                    _c("span", { staticClass: "d-flex pt-2 pl-0" }, [
                      _c("span", { staticClass: "font-size-13 mr-3" }, [
                        _c("span", { staticClass: "d-flex w-100" }, [
                          _c("span", { staticStyle: { width: "120px" } }, [
                            _vm._v(" Plan Voice Clones "),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.user.custom_voice_limit) + " "
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "d-flex w-100" }, [
                          _c("span", { staticStyle: { width: "120px" } }, [
                            _vm._v(" Remaining Clones "),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.user.remaining_voice_clones) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("span", { staticClass: "font-size-13" }, [
                        _c("span", { staticClass: "d-flex w-100" }, [
                          _c("span", { staticStyle: { width: "120px" } }, [
                            _vm._v(" Plan Minutes "),
                          ]),
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.user.total_credits) + " "),
                          ]),
                        ]),
                        _c("span", { staticClass: "d-flex w-100" }, [
                          _c("span", { staticStyle: { width: "120px" } }, [
                            _vm._v(" Remaining Minutes "),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.user.remaining_credits) + " "
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "d-flex align-items-center ml-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-dark-blue rounded-0 btn-sm",
                              attrs: { to: { name: "agency.subscription" } },
                            },
                            [_vm._v("Upgrade")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "ul",
            {
              staticClass:
                "navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0",
            },
            [
              _vm.user && _vm.user.role === "Admin"
                ? _c(
                    "li",
                    { staticClass: "mt-auto mb-auto mr-4" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-light",
                          attrs: { to: { name: "admin.agencies.create" } },
                        },
                        [
                          _c("i", { staticClass: "uil uil-plus" }),
                          _vm._v(" New Agency "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "user-list",
                  attrs: {
                    id: "user-info",
                    right: "",
                    variant: "white",
                    "menu-class": "dropdown-lg",
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.user
                        ? {
                            key: "button-content",
                            fn: function () {
                              return [
                                _c("img", {
                                  staticClass: "avatar-sm rounded-circle mr-2",
                                  attrs: { src: _vm.user.avatar },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-primary font-weight-bold",
                                  },
                                  [_vm._v(_vm._s(_vm.user.full_name))]
                                ),
                                _c("feather", {
                                  staticClass: "align-middle ml-2",
                                  attrs: { type: "chevron-down" },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm.user && _vm.user.total_credits > 0
                    ? _c(
                        "b-dropdown-item",
                        { staticClass: "d-block d-sm-none" },
                        [
                          _c("strong", { staticClass: "mb-1 d-block" }, [
                            _vm._v("Minutes:"),
                          ]),
                          _c("div", { staticClass: "d-flex w-100" }, [
                            _c("span", { staticClass: "flex-grow-1" }, [
                              _vm._v(" Total "),
                            ]),
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.user.total_credits) + " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "d-flex w-100" }, [
                            _c("span", { staticClass: "flex-grow-1" }, [
                              _vm._v(" Remaining "),
                            ]),
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.user.remaining_credits) + " "
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.user && _vm.user.total_credits > 0
                    ? _c("b-dropdown-divider")
                    : _vm._e(),
                  _vm.isImpersonating
                    ? _c(
                        "b-dropdown-item",
                        { on: { click: _vm.stopImpersonate } },
                        [
                          _c("feather", {
                            staticClass: "icon-dual icon-xs mr-2",
                            attrs: { type: "log-in" },
                          }),
                          _c("span", [_vm._v("Main account")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.user
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: {
                              name: `${_vm.userRole.toLocaleLowerCase()}.profile`,
                            },
                          },
                        },
                        [
                          _c("feather", {
                            staticClass: "icon-dual icon-xs mr-2",
                            attrs: { type: "user" },
                          }),
                          _c("span", [_vm._v("My Account")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("b-dropdown-divider"),
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "notify-item p-0",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("feather", {
                        staticClass: "icon-dual icon-xs mr-2",
                        attrs: { type: "log-out" },
                      }),
                      _c("span", [_vm._v("Logout")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }